/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { TickerAuctioneerLotStateDto } from '../models/ticker-auctioneer-lot-state-dto';

@Injectable({
  providedIn: 'root',
})
export class GeneratedTickerAuctioneerLotStateService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getTickerAuctioneerLotState
   */
  static readonly GetTickerAuctioneerLotStatePath = '/api/ticker/lot-auctioneer-states/{id}';

  /**
   * Gets the auctioneer state of lot by its id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTickerAuctioneerLotState()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTickerAuctioneerLotState$Response(params: {
    id: number;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<TickerAuctioneerLotStateDto>> {

    const rb = new RequestBuilder(this.rootUrl, GeneratedTickerAuctioneerLotStateService.GetTickerAuctioneerLotStatePath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.header('X-API-Version', params['X-API-Version'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TickerAuctioneerLotStateDto>;
      })
    );
  }

  /**
   * Gets the auctioneer state of lot by its id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTickerAuctioneerLotState$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTickerAuctioneerLotState(params: {
    id: number;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<TickerAuctioneerLotStateDto> {

    return this.getTickerAuctioneerLotState$Response(params,context).pipe(
      map((r: StrictHttpResponse<TickerAuctioneerLotStateDto>) => r.body as TickerAuctioneerLotStateDto)
    );
  }

}
